/**
 * John White Shoes — Custom JavaScript
 * Compatible with Symmetry 7.4.0
 */
(function() {
  'use strict';

  // == SCROLL REVEAL ==
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var d = el.getAttribute('data-d');
          if (d) el.style.transitionDelay = (d * 0.12) + 's';
          el.classList.add('vis');
          ro.unobserve(el);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.rv,.rvl,.rvr').forEach(function(el) { ro.observe(el); });
  } else {
    document.querySelectorAll('.rv,.rvl,.rvr').forEach(function(el) { el.classList.add('vis'); });
  }
  setTimeout(function() {
    document.querySelectorAll('.rv,.rvl,.rvr').forEach(function(el) { el.classList.add('vis'); });
  }, 3000);

  // == BACK TO TOP ==
  var btt = document.getElementById('btt');
  if (btt) {
    window.addEventListener('scroll', function() {
      btt.classList.toggle('vis', window.scrollY > 600);
    }, { passive: true });
    btt.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // == COOKIE CONSENT ==
  // Legacy custom banner (kept for safety if ever re-added).
  var ckBanner = document.getElementById('ckBanner');
  if (ckBanner) {
    try {
      if (!localStorage.getItem('jw_ck')) {
        setTimeout(function() { ckBanner.classList.add('vis'); }, 2000);
      }
    } catch (e) {
      setTimeout(function() { ckBanner.classList.add('vis'); }, 2000);
    }
  }

  // Shopify native Customer Privacy banner — defer reveal + shorten copy.
  // Triggers (first to fire wins): 20s dwell | 45% scroll | 2nd pageview | product page +8s.
  // 19 Oct 2026 (AK yes): shown AT ONCE (TIMER_MS 0, Shopify's default). The 8s/20s hold meant most
  // paid visitors left unasked, so no tag fired for them. Accept is labelled 'Accept all'; the
  // banner's buttons are not restyled.
  (function deferShopifyConsentBanner() {
    var SHOW_CLASS = 'jw-ck-show';
    var SESSION_KEY = 'jw_pv';
    var PATH = window.location.pathname || '';
    var TIMER_MS = 0;   // was: /\/products\//.test(PATH) ? 8000 : 20000 (19 Oct 2026)
    var SCROLL_PCT = 0.45;
    var shownImmediately = false;
    var revealed = false;

    try {
      var pv = parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10) + 1;
      sessionStorage.setItem(SESSION_KEY, String(pv));
      if (pv >= 2) shownImmediately = true;
    } catch (e) {}

    function shortenCopy(banner) {
      var p = banner.querySelector('.shopify-pc__banner__body p');
      if (!p || p.dataset.jwShort) return;
      var existingLink = p.querySelector('a');
      var href = (existingLink && existingLink.getAttribute('href')) || '/policies/privacy-policy';
      while (p.firstChild) p.removeChild(p.firstChild);
      p.appendChild(document.createTextNode('We use cookies for stats and ads. '));  // 3 Nov 2026 (AK): one line on a phone, plain purposes
      var a = document.createElement('a');
      a.setAttribute('href', href);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
      a.textContent = 'Learn more';
      p.appendChild(a);
      p.dataset.jwShort = '1';
      var acc = banner.querySelector('#shopify-pc__banner__btn-accept');
      if (acc && !acc.dataset.jwLabel) { acc.textContent = 'Accept all'; acc.dataset.jwLabel = '1'; }
      var dec = banner.querySelector('#shopify-pc__banner__btn-decline');
      if (dec && !dec.dataset.jwLabel) { dec.textContent = 'No thanks'; dec.dataset.jwLabel = '1'; }  // 3 Nov 2026: softer, same button, equally easy
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      document.body.classList.add(SHOW_CLASS);
    }

    function onBannerReady(banner) {
      shortenCopy(banner);
      if (shownImmediately) { reveal(); return; }

      var timer = setTimeout(reveal, TIMER_MS);

      var onScroll = function() {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h >= SCROLL_PCT) {
          clearTimeout(timer);
          window.removeEventListener('scroll', onScroll);
          reveal();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      ['shopify-pc__banner__btn-accept', 'shopify-pc__banner__btn-decline'].forEach(function(id) {
        var b = document.getElementById(id);
        if (b) b.addEventListener('click', function() {
          try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
        });
      });
    }

    function findAndWire() {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner) { onBannerReady(banner); return true; }
      return false;
    }

    if (!findAndWire()) {
      var tries = 0;
      var mo = new MutationObserver(function() {
        if (findAndWire() || ++tries > 40) mo.disconnect();
      });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() { mo.disconnect(); }, 15000);
    }
  })();

  // == EXIT-INTENT POPUP ==
  var exitPopup = document.getElementById('exitPopup');
  var exitClose = document.getElementById('exitClose');
  var exitShown = false;
  if (exitPopup) {
    document.addEventListener('mouseout', function(e) {
      if (exitShown) return;
      try { if (localStorage.getItem('jw_exit')) return; } catch (ex) {}
      if (e.clientY < 5 && e.relatedTarget === null) {
        exitShown = true;
        exitPopup.classList.add('open');
        try { localStorage.setItem('jw_exit', '1'); } catch (ex) {}
      }
    });
    if (exitClose) exitClose.addEventListener('click', function() { exitPopup.classList.remove('open'); });
    exitPopup.addEventListener('click', function(e) { if (e.target === exitPopup) exitPopup.classList.remove('open'); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && exitPopup.classList.contains('open')) exitPopup.classList.remove('open');
    });
  }

  // == SEARCH OVERLAY ==
  var searchOverlay = document.getElementById('searchOverlay');
  var searchClose = document.getElementById('searchClose');
  if (searchOverlay && searchClose) {
    searchClose.addEventListener('click', function() { searchOverlay.classList.remove('open'); });
    searchOverlay.addEventListener('click', function(e) { if (e.target === searchOverlay) searchOverlay.classList.remove('open'); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('open')) searchOverlay.classList.remove('open');
    });
  }

  // == STRIP .00 FROM PRICES ==
  function stripZeroPence(root) {
    root.querySelectorAll('.theme-money, .price__current, .price__was, .product-price, .cart-item__price, .subtotal .theme-money, .jw-outlet__card-now, .jw-outlet__card-was').forEach(function(el) {
      if (el.childElementCount === 0 && el.textContent.indexOf('.00') > -1) {
        el.textContent = el.textContent.replace(/\.00/g, '');
      }
    });
  }
  stripZeroPence(document);
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType === 1) stripZeroPence(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // == SMOOTH ANCHOR SCROLL ==
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var t = document.querySelector(this.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // == CENTRE SMALL DROPDOWNS UNDER PROXY-NAV TRIGGER ==
  // Approach: position:fixed via CSS + JS that, on hover, computes the trigger's viewport
  // centre and writes left directly to the dropdown. Stash debug info on data-attrs so we
  // can see what's happening if the position still drifts.
  (function(){
    var proxyNav = document.getElementById('proxy-nav');
    var mainNav = document.getElementById('main-nav');
    if (!proxyNav || !mainNav) return;

    var proxyItems = proxyNav.querySelectorAll('.navigation__tier-1 > .navigation__item--with-small-menu');
    var mainItems = mainNav.querySelectorAll('.navigation__tier-1 > .navigation__item');

    // 8 Oct 2026: the dropdown's top = the header's live bottom edge, written to
    // --jw-nav-drop-top (jw-custom.css reads it). Measured, not assumed: the announcement
    // bar above the header is one or two lines tall and scrolls away under the sticky header.
    var headerEl = mainNav.closest('.shopify-section') || mainNav.closest('page-header') || mainNav;
    function setDropTop(){
      var b = headerEl.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--jw-nav-drop-top', Math.max(0, Math.floor(b)) + 'px');
    }
    var dropTicking = false;
    function queueDropTop(){
      if (dropTicking) return;
      dropTicking = true;
      requestAnimationFrame(function(){ dropTicking = false; setDropTop(); });
    }
    setDropTop();
    window.addEventListener('scroll', queueDropTop, { passive: true });
    window.addEventListener('resize', queueDropTop);
    window.addEventListener('load', queueDropTop);

    // Build trigger→dropdown pairs by index in the FULL parent list (not the small-menu subset)
    proxyItems.forEach(function(triggerItem){
      var allProxySiblings = Array.prototype.filter.call(triggerItem.parentNode.children, function(n){
        return n.tagName === 'LI';
      });
      var idx = allProxySiblings.indexOf(triggerItem);
      var mainItem = mainItems[idx];
      if (!mainItem) return;
      var dropdown = mainItem.querySelector('.navigation__tier-2-container');
      if (!dropdown) return;

      function place(){
        setDropTop();
        var r = triggerItem.getBoundingClientRect();
        if (r.width === 0) return; // trigger not visible
        // Force-measure dropdown by temporarily showing
        var prev = dropdown.style.visibility;
        dropdown.style.visibility = 'hidden';
        dropdown.style.display = 'block';
        var w = dropdown.getBoundingClientRect().width;
        dropdown.style.display = '';
        dropdown.style.visibility = prev;
        if (!w) w = 240;
        var newLeft = Math.round(r.left + r.width / 2 - w / 2);
        if (newLeft < 8) newLeft = 8;
        if (newLeft + w > window.innerWidth - 8) newLeft = window.innerWidth - w - 8;
        dropdown.style.setProperty('left', newLeft + 'px', 'important');
        dropdown.style.setProperty('right', 'auto', 'important');
      }

      triggerItem.addEventListener('mouseenter', function(){ requestAnimationFrame(place); });
      triggerItem.addEventListener('focusin', function(){ requestAnimationFrame(place); });
      window.addEventListener('resize', function(){ requestAnimationFrame(place); });

      // MutationObserver: any time theme JS rewrites style, re-place
      var lastMs = 0;
      var mo = new MutationObserver(function(){
        if (Date.now() - lastMs < 30) return;
        lastMs = Date.now();
        place();
      });
      mo.observe(dropdown, { attributes: true, attributeFilter: ['style'] });

      // Initial placement (after styles settle)
      setTimeout(place, 100);
    });
  })();

  // == INNER CIRCLE NEWSLETTER POPUP ==
  // Trigger rules: show 15s after first page load OR on exit-intent (whichever first).
  // Suppress for 30 days if dismissed; never show again if submitted (Shopify form posts
  // create the customer record + accepts_marketing flag, which Mailchimp picks up via the
  // existing Shopify→Mailchimp integration).
  (function(){
    var pop = document.getElementById('icPop');
    if (!pop) return;

    var KEY = 'jw_ic_pop_v1';
    // Session-scoped marker, written the instant THIS popup's form is submitted.
    // Shopify's {% form 'customer' %} posts natively and reloads the page, so after the
    // reload this is the only way to tell that the popup was the thing submitted rather
    // than the newsletter section — a successful customer post makes
    // form.posted_successfully? true on EVERY customer form on the page, so without the
    // marker the modal would also fly open over someone who used the footer signup.
    var PENDING_KEY = 'jw_ic_pop_pending';
    var DISMISS_DAYS = 30;
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch(e) {}

    function save(patch){
      try {
        var next = Object.assign({}, stored, patch);
        localStorage.setItem(KEY, JSON.stringify(next));
        stored = next;
      } catch(e){}
    }

    function open(){
      if (pop.getAttribute('aria-hidden') === 'false') return;
      pop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var input = document.getElementById('icPopEmail');
      setTimeout(function(){ if (input) input.focus(); }, 350);
    }
    function close(reason){
      pop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      save({ dismissedAt: Date.now(), reason: reason || 'close' });
    }

    // Close handlers
    var btnClose = document.getElementById('icPopClose');
    var btnSkip = document.getElementById('icPopSkip');
    var backdrop = document.getElementById('icPopBackdrop');
    if (btnClose) btnClose.addEventListener('click', function(){ close('close'); });
    if (btnSkip) btnSkip.addEventListener('click', function(){ close('skip'); });
    if (backdrop) backdrop.addEventListener('click', function(){ close('backdrop'); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && pop.getAttribute('aria-hidden') === 'false') close('esc');
    });

    // ── Re-open on the post-submit reload so the customer actually SEES the code ──
    // 16 Sep 2026 BUGFIX. This block used to sit BELOW `if (stored.submitted) return`,
    // which made it unreachable. The submit handler writes submitted:true, the form then
    // posts natively and the page reloads — and on that reload the early return fired
    // first and the function exited before it could re-open the popup. The JW15
    // confirmation was rendered into the DOM on every single popup signup and shown to
    // nobody, which is why people said they signed up and never got a code. The
    // suppression returns now sit AFTER this check, not before it.
    var pending = false;
    try { pending = sessionStorage.getItem(PENDING_KEY) === '1'; } catch(e){}
    if (pending) {
      try { sessionStorage.removeItem(PENDING_KEY); } catch(e){}
      if (pop.querySelector('.ic-pop__ok')) {
        open();
        return;
      }
      // Posted, but no confirmation rendered — Shopify rejected it (malformed address,
      // already a customer). Undo the "never show again" flag the submit handler set,
      // otherwise one rejected attempt suppresses the popup for good and that person
      // can never sign up at all.
      save({ submitted: false });
    }

    if (stored.submitted) return;
    if (stored.dismissedAt && (Date.now() - stored.dismissedAt) < DISMISS_DAYS*86400000) return;

    // On submit, mark as submitted so we never show again (the form posts to Shopify
    // natively), and set the session marker the re-open check above reads.
    var form = document.getElementById('icPopForm');
    if (form) form.addEventListener('submit', function(){
      save({ submitted: true, submittedAt: Date.now() });
      try { sessionStorage.setItem(PENDING_KEY, '1'); } catch(e){}
    });

    // ── Research-based trigger (first signal to fire wins) ────────────────
    // CRO studies (Sleeknote, OptinMonster, Privy) consistently show that
    // pop-ups shown immediately suppress conversion, raise bounce, and risk
    // Google's intrusive-interstitial penalty on mobile. Engagement signals
    // convert far better, so we hold the pop-up back until one of:
    //   • 30s dwell        — visitor is genuinely reading, not bouncing through
    //   • 50% scroll depth — clear browsing intent (fires sooner for engaged users)
    //   • exit-intent      — desktop visitor about to leave (last chance to capture)
    var fired = false;
    function trigger(){
      if (fired) return;
      fired = true;
      clearTimeout(dwellTimer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', exitHandler);
      open();
    }

    // 7 Jul 2026: NO dwell or scroll trigger on product pages — 30s on a PDP is
    // consideration, not exit, and a 10%-off interruption mid-purchase (on top of
    // sale pricing) is the worst possible moment. PDPs keep exit-intent only.
    var onProductPage = document.body.classList.contains('template-product');
    var dwellTimer = onProductPage ? null : setTimeout(trigger, 30000);

    // 6 Jul 2026: scroll trigger DESKTOP ONLY. On mobile, 50% depth on a long
    // collection page fires mid-browse and covers the product grid — the worst
    // possible moment. Mobile keeps the 30s dwell (exit-intent needs a cursor).
    var isMobileViewport = window.matchMedia('(max-width: 767.98px)').matches;
    function onScroll(){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.scrollY / h) >= 0.5) trigger();
    }
    if (!isMobileViewport && !onProductPage) window.addEventListener('scroll', onScroll, { passive: true });

    function exitHandler(e){
      if (e.clientY <= 0) trigger();
    }
    document.addEventListener('mouseout', exitHandler);
  })();

  // == LOCK SCROLL ON VARIANT CHANGE (PDP) ==
  // Symmetry's setActiveMedia() calls theme.scrollToRevealElement() on the collage when
  // a variant changes — that's the unwanted page jump on size click. Belt-and-braces fix:
  //   (a) capture-phase listeners on every relevant event, pin scrollY back across frames
  //   (b) intercept clicks on variant-picker controls and pin scrollY for ~400ms
  //   (c) once theme.scrollToRevealElement is defined, wrap it to be a no-op on PDPs
  if (document.body.className.indexOf('template-product') > -1) {
    var pinUntil = 0;
    var pinnedY = 0;

    function startPin() {
      pinnedY = window.scrollY;
      pinUntil = performance.now() + 500;
      var loop = function() {
        if (performance.now() > pinUntil) return;
        if (Math.abs(window.scrollY - pinnedY) > 1) window.scrollTo(0, pinnedY);
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    }

    // Click anywhere inside the variant picker = pin scroll for the next 500ms.
    document.addEventListener('click', function(e) {
      if (e.target.closest('variant-picker, .variant-picker, .variant-input-wrap, .option-selector')) {
        startPin();
      }
    }, true);

    // Belt: also catch the change/variant events.
    ['change','on:variant:change','variant:change'].forEach(function(evt){
      document.addEventListener(evt, function(e){
        if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker')) {
          startPin();
        } else if (evt !== 'change') {
          startPin();
        }
      }, true);
    });

    // Braces: monkey-patch theme.scrollToRevealElement once it exists.
    var patchTries = 0;
    var tryPatch = function() {
      if (window.theme && typeof window.theme.scrollToRevealElement === 'function' && !window.theme.scrollToRevealElement.__jwPatched) {
        var orig = window.theme.scrollToRevealElement;
        window.theme.scrollToRevealElement = function() {
          if (document.body.className.indexOf('template-product') > -1) return; // no-op on PDPs
          return orig.apply(this, arguments);
        };
        window.theme.scrollToRevealElement.__jwPatched = true;
        return;
      }
      if (++patchTries < 30) setTimeout(tryPatch, 100);
    };
    tryPatch();
  }

  // == RECENTLY VIEWED ==
  try {
    if (document.body.className.indexOf('template-product') > -1) {
      var title = document.querySelector('.product-title, .product-area h1, [data-product-title]');
      var img = document.querySelector('.product-main-image img, .media-gallery img');
      // Capture current price + compare-at price so the recently-viewed cards can show pricing.
      var priceEl = document.querySelector('.product-info__price .price__current, .price__current, .product-price .money, [data-product-price]');
      var compareEl = document.querySelector('.product-info__price .price__was, .price__was, .product-price--compare-at .money, [data-compare-price]');
      if (title && img) {
        var viewed = JSON.parse(localStorage.getItem('jw_viewed') || '[]');
        var item = {
          name: title.textContent.trim(),
          img: img.src,
          url: window.location.href,
          price: priceEl ? priceEl.textContent.trim() : '',
          compare: compareEl ? compareEl.textContent.trim() : ''
        };
        viewed = viewed.filter(function(v) { return v.name !== item.name; });
        viewed.unshift(item);
        if (viewed.length > 6) viewed = viewed.slice(0, 6);
        localStorage.setItem('jw_viewed', JSON.stringify(viewed));
      }
    }
  } catch (e) {}
})();

  // == DRAG SCROLL for product tracks ==
  document.querySelectorAll('.jw-fc__track, .jw-reviews__grid').forEach(function(track) {
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function(e) {
      isDown = true; track.style.cursor = 'grabbing';
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function() { isDown = false; track.style.cursor = 'grab'; });
    track.addEventListener('mouseup', function() { isDown = false; track.style.cursor = 'grab'; });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  });

  // == CART DRAWER — DISCOUNT/VOUCHER CODE (15 May 2026) ==
  (function() {
    function init() {
      // Toggle expand
      document.addEventListener('click', function(e) {
        var t = e.target.closest('[data-jw-discount-toggle]');
        if (t) {
          e.preventDefault();
          var wrap = t.closest('[data-jw-discount]');
          var panel = wrap.querySelector('[data-jw-discount-panel]');
          var open = t.getAttribute('aria-expanded') === 'true';
          t.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) {
            panel.setAttribute('hidden', '');
          } else {
            panel.removeAttribute('hidden');
            setTimeout(function() {
              var inp = panel.querySelector('[data-jw-discount-input]');
              if (inp) inp.focus();
            }, 50);
          }
        }
      });

      // Apply on button click or Enter key
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-jw-discount-apply]')) {
          e.preventDefault();
          applyDiscount(e.target.closest('[data-jw-discount]'));
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && e.target.matches('[data-jw-discount-input]')) {
          e.preventDefault();
          applyDiscount(e.target.closest('[data-jw-discount]'));
        }
      });
    }

    function setMsg(wrap, txt, cls) {
      var msg = wrap.querySelector('[data-jw-discount-msg]');
      msg.textContent = txt || '';
      msg.classList.remove('jw-discount__msg--ok', 'jw-discount__msg--err');
      if (cls) msg.classList.add('jw-discount__msg--' + cls);
    }

    async function applyDiscount(wrap) {
      var input = wrap.querySelector('[data-jw-discount-input]');
      var btn = wrap.querySelector('[data-jw-discount-apply]');
      var code = (input.value || '').trim();
      if (!code) {
        setMsg(wrap, 'Please enter a code.', 'err');
        return;
      }
      btn.disabled = true;
      setMsg(wrap, 'Applying…');

      try {
        // Shopify Ajax cart: apply discount code via /cart/update.js
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        var cart = await res.json();

        // Check if discount actually applied
        var applied = (cart.discount_codes || []).find(function(d) {
          return d.code && d.code.toLowerCase() === code.toLowerCase() && d.applicable;
        });

        if (applied) {
          setMsg(wrap, 'Code applied — saving on your order.', 'ok');
          input.value = '';
          // Trigger cart drawer refresh so subtotal and discount lines update
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        } else {
          // Not applicable (expired, doesn't meet conditions, or invalid)
          var notApplicable = (cart.discount_codes || []).find(function(d) {
            return d.code && d.code.toLowerCase() === code.toLowerCase();
          });
          if (notApplicable) {
            setMsg(wrap, wrap.getAttribute('data-jw-nocode') || 'Code recognised but not applicable to this order.', 'err');
          } else {
            setMsg(wrap, 'Code not valid. Check spelling and try again.', 'err');
          }
        }
      } catch (err) {
        setMsg(wrap, 'Something went wrong. Please try again.', 'err');
      } finally {
        btn.disabled = false;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // == APPLIED DISCOUNT × REMOVE BUTTON (16 May 2026) ==
  (function() {
    document.addEventListener('click', async function(e) {
      var btn = e.target.closest('[data-jw-discount-remove]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      try {
        // Clear applied discount codes (Shopify Ajax cart accepts empty string)
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
        await res.json();
        // Refresh the cart drawer so the chip + subtotal update
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      } catch (err) {
        btn.disabled = false;
      }
    });
  })();


  // == STICKY MOBILE ADD-TO-BAG BAR (15 May 2026) ==
  (function() {
    if (!document.body.classList.contains('template-product')) return;
    if (window.innerWidth >= 768) return;

    function init() {
      // Locate the main ATB button + product info
      var mainBtn = document.querySelector('product-form button[name="add"], main button[name="add"], .product-info button[name="add"]');
      if (!mainBtn) return;

      var titleEl = document.querySelector('.product-info h1, .product-title, h1.product-info__title');
      var priceCurrent = document.querySelector('.product-info__price .price__current, .product-price .price__current, .price__current');
      var priceWas = document.querySelector('.product-info__price .price__was, .product-price .price__was, .price__was');
      var imgEl = document.querySelector('.product-gallery img, .product-images img, .product-media img, .product__media img');

      if (!titleEl) return;

      // Build sticky bar
      var bar = document.createElement('div');
      bar.className = 'jw-atb';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = [
        '<div class="jw-atb__img">',
        imgEl ? '<img src="' + imgEl.currentSrc.replace(/&width=\\d+/, '&width=120') + '" alt="" />' : '',
        '</div>',
        '<div class="jw-atb__info">',
        '  <p class="jw-atb__title">' + (titleEl.textContent || '').trim() + '</p>',
        '  <p class="jw-atb__price">',
        priceWas ? '<span class="jw-atb__price-was">' + priceWas.textContent.trim() + '</span>' : '',
        priceCurrent ? priceCurrent.textContent.trim() : '',
        '  </p>',
        '</div>',
        '<button type="button" class="jw-atb__btn" data-jw-atb-trigger>Add to Bag</button>'
      ].join('');
      document.body.appendChild(bar);

      // Wire trigger -> main button click
      // 19 Sep 2026 BUGFIX. The size check below used selectors from another theme
      // (options[Size], fieldset[data-product-option]) and matched NOTHING here, so a tap
      // with no size chosen fell through to mainBtn.click(). The theme then printed
      // "CHOOSE A SIZE" beside the main button, 200px below the fold, and the person who
      // tapped the bar saw nothing happen at all. On a phone this bar is the first thing a
      // thumb reaches: paid social on mobile adds to cart at 3.1% and the dead tap is on
      // every product page. Now: find the size group by what it holds, take them to it,
      // and say why.
      function sizeGroup() {
        var groups = document.querySelectorAll('fieldset.option-selector, .option-selector');
        for (var i = 0; i < groups.length; i++) {
          var first = groups[i].querySelector('input.js-option, input[type="radio"]');
          var legend = groups[i].querySelector('legend, .option-selector__label, .label');
          if ((first && /^(UK|EU|US)?\s?\d/i.test(first.value)) ||
              (legend && /size/i.test(legend.textContent))) return groups[i];
        }
        return null;
      }
      bar.querySelector('[data-jw-atb-trigger]').addEventListener('click', function() {
        var group = sizeGroup();
        if (group && !group.querySelector('input:checked')) {
          group.scrollIntoView({ behavior: 'smooth', block: 'center' });
          group.style.outline = '2px solid #c4a868'; group.style.outlineOffset = '10px';
          setTimeout(function(){ group.style.outline = ''; group.style.outlineOffset = ''; }, 2400);
          var btn = this, was = btn.textContent;
          btn.textContent = 'Choose a size';
          setTimeout(function(){ btn.textContent = was; }, 2400);
          return;
        }
        mainBtn.click();
      });

      // Sync state from main button (disabled if sold out, label change)
      function syncState() {
        var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
        var btn = bar.querySelector('[data-jw-atb-trigger]');
        if (disabled) {
          btn.disabled = true;
          btn.textContent = mainBtn.textContent.trim() || 'Unavailable';
        } else {
          btn.disabled = false;
          btn.textContent = 'Add to Bag';
        }
      }
      syncState();
      new MutationObserver(syncState).observe(mainBtn, { attributes: true, childList: true, subtree: true });

      // IntersectionObserver: hide bar when main button is in view
      var io = new IntersectionObserver(function(entries) {
        var inView = entries[0].isIntersecting;
        if (inView) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      }, { threshold: 0.05 });
      io.observe(mainBtn);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // SAVE FOR LATER removed 15 May 2026 per AK request.

/* FIX 4 Jul 2026: strip ".00" from JS-rendered prices (variant switch, cart drawer,
   quick buy). Display only - genuine pence like 12.50 are kept. Static Liquid
   renders already use money_without_trailing_zeros. */
(function () {
  var TEST = /\u00a3\d[\d,]*\.00(?!\d)/;
  var REPL = /(\u00a3\d[\d,]*)\.00(?!\d)/g;
  function strip(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return TEST.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; }
    });
    var nodes = [];
    while (w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach(function (n) { n.nodeValue = n.nodeValue.replace(REPL, '$1'); });
  }
  var t;
  function scan() {
    ['.price', '.theme-money', '.product-block__price', '.cart-drawer', '.quick-buy', '[data-price]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { strip(el); });
    });
  }
  function arm() {
    scan();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 80); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();

// == PDP MOBILE GALLERY COUNTER (6 Jul 2026) ==
// The mobile thumbnail strip is hidden (jw-custom.css) — it duplicated the swipe
// gesture and burned ~180px of viewport. This keeps the "2 / 6" counter in sync.
// carousel-slider dispatches on:carousel-slider:select (bubbles) when
// data-dispatch-events="true" — the PDP main carousel sets that.
(function () {
  document.addEventListener('on:carousel-slider:select', function (e) {
    var slider = e.target;
    if (!slider.matches || !slider.matches('carousel-slider')) return;
    var counter = slider.querySelector('.jw-gallery-counter__current');
    if (counter && typeof e.detail?.index === 'number') {
      counter.textContent = e.detail.index + 1;
    }
  });
})();

// == PDP SIZE GUIDE LINK (6 Jul 2026) ==
// "Size guide" beside the SIZE label opens the "How they fit" accordion and
// scrolls to it — the guidance already exists on the page, just buried.
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-jw-size-guide]');
    if (!link) return;
    e.preventDefault();
    var target = null;
    document.querySelectorAll('details').forEach(function (d) {
      if (target) return;
      var s = d.querySelector('summary');
      if (s && /how they fit|size guide|fit guide/i.test(s.textContent)) target = d;
    });
    if (target) {
      target.open = true;
      setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 60);
    }
  });
})();

// == SWATCH ROW SWIPE AFFORDANCE (6 Jul 2026) ==
// Toggles .jw-scrollable on swatch containers whose row overflows (shows the
// edge-fade + chevron from jw-custom.css) and .jw-at-end when fully scrolled.
// Covers collection/related cards and the PDP colour picker. Re-scans on DOM
// changes (AJAX pagination, quick buy) via the same throttled-observer pattern
// used elsewhere in this file.
(function () {
  function update(scroller, host) {
    var scrollable = scroller.scrollWidth > scroller.clientWidth + 2;
    host.classList.toggle('jw-scrollable', scrollable);
    var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
    host.classList.toggle('jw-at-end', !scrollable || atEnd);
  }
  var wired = [];
  function wire(scroller, host) {
    if (!scroller || !host || scroller.dataset.jwAffordance) return;
    scroller.dataset.jwAffordance = '1';
    wired.push([scroller, host]);
    scroller.addEventListener('scroll', function () { update(scroller, host); }, { passive: true });
    update(scroller, host);
  }
  function scan() {
    document.querySelectorAll('.product-block-options--swatch .product-block-options__inner').forEach(function (s) {
      wire(s, s.closest('.product-block-options--swatch'));
    });
    document.querySelectorAll('.option-selector[data-option="Color"] .option-selector__btns').forEach(function (s) {
      wire(s, s.closest('.option-selector'));
    });
  }
  function refreshAll() { wired.forEach(function (w) { update(w[0], w[1]); }); }
  var t;
  function arm() {
    scan();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); })
      .observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(refreshAll, 150); }, { passive: true });
    // swatch images lazy-load after first paint and change scrollWidth
    setTimeout(refreshAll, 1500);
    setTimeout(refreshAll, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();

// == DESKTOP PDP SMART STICKY BUY COLUMN (7 Jul 2026) ==
// The buy column is taller than the viewport, so a plain sticky top-pin would
// leave its lower half unreachable. This scroll-through pattern lets the column
// move naturally with the page: scrolling down settles it bottom-pinned,
// scrolling up brings it back to top-pinned. CSS provides position:sticky
// (sticky-content-container); we only steer the `top` offset.
(function () {
  if (!document.body.classList.contains('template-product')) return;
  if (!window.matchMedia('(min-width: 768px)').matches) return;
  var form = document.querySelector('.product-column-right .product-form.sticky-content-container');
  if (!form) return;
  var TOP_GAP = 24;
  var BOTTOM_GAP = 24;
  var offset = TOP_GAP;
  var lastY = window.scrollY;
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function onScroll() {
    var y = window.scrollY;
    var fh = form.offsetHeight;
    var vh = window.innerHeight;
    if (fh <= vh - TOP_GAP - BOTTOM_GAP) {
      form.style.setProperty('top', TOP_GAP + 'px', 'important');
      lastY = y;
      return;
    }
    var minTop = vh - fh - BOTTOM_GAP;   // bottom-pinned (negative)
    offset = clamp(offset - (y - lastY), minTop, TOP_GAP);
    form.style.setProperty('top', offset + 'px', 'important');
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
})();
